import { render } from "./TradingGoods.vue?vue&type=template&id=62bd1017&scoped=true"
import script from "./TradingGoods.vue?vue&type=script&lang=js"
export * from "./TradingGoods.vue?vue&type=script&lang=js"

import "./TradingGoods.vue?vue&type=style&index=0&id=62bd1017&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bd1017"]])

export default __exports__